import { createReducer, on } from '@ngrx/store';

import {
  clearFlightOfferAction,
  fetchHomeFlightOffersSuccessAction
} from '@home-item-detail/store/actions/home-item-detail.actions';
import { HomeFlightOffers } from '@shared/home-sections/entities/home-data.response';

export const initialState: HomeFlightOffers[] = [];
export const recentFlightOfferReducer = createReducer(
  initialState,
  on(fetchHomeFlightOffersSuccessAction, (state, { response }) => {
    return response;
  }),
  on(clearFlightOfferAction, (state) => {
    return [] as HomeFlightOffers[];
  }),
);
